<template>
  <li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#"><b><i v-bind:class="icon"></i>{{type}}{{username}}</b></a>
    <div class="dropdown-menu">
      <router-link :to="{ name: 'Logout'}"><button class="btn btn-default form-control" type="button">ออกจากระบบ <span class="fas fa-sign-out-alt"></span></button></router-link>
    </div>
  </li>
</template>
<script>
export default {
  name: 'DefaultHeaderDropdown',
  props: {
    username: '',
    type: '',
    icon: ''
  }
}
</script>